const DotBigIcon = ({ color = '#43A75A' }: { color?: string }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='9' height='8' viewBox='0 0 9 8' fill='none'>
      <circle cx='4.59961' cy='4' r='4' fill={color} />
    </svg>
  )
}

export { DotBigIcon }
